import React from 'react'
import styled from 'styled-components'

const PageSubtitle = styled.h2`
  margin-bottom: 25px;
  font-family: Poppins;
  font-weight: 600;
  font-size: 18px;
  color: #B2B4C2;
`

export const Subtitle: React.FC = ({ children }) => (
  <PageSubtitle>{ children }</PageSubtitle>
)

export default Subtitle
